import { useCallback } from 'react'

type FilterItem = {
	id: number
	title: string
	description?: string
	group?: string
	disabled?: boolean
}

/**
 * Переиспользуемый хук для переключения фильтров в списках
 * @param filterKey - ключ фильтра в состоянии
 * @param availableList - список доступных элементов
 * @param setActiveFilters - функция обновления фильтров
 * @returns мемоизированная функция для обработки клика
 */
export const useFilterToggle = (
	filterKey: string,
	availableList: FilterItem[] | undefined,
	setActiveFilters: (updater: (prev: any) => any) => void,
) => {
	return useCallback(
		(id: number) => {
			setActiveFilters((prev: any) => {
				const currentIds = filterKey.includes('.')
					? filterKey.split('.').reduce((obj, key) => obj[key], prev)
					: prev[filterKey]

				const findItem = availableList?.find(el => el.id === id)
				if (!findItem) return prev

				const isPresent = Array.isArray(currentIds)
					? currentIds.includes(findItem.id)
					: currentIds === findItem.id

				let updatedIds
				if (Array.isArray(currentIds)) {
					updatedIds = isPresent
						? currentIds.filter((item: number) => item !== findItem.id)
						: [...currentIds, findItem.id]
				} else {
					updatedIds = isPresent ? undefined : findItem.id
				}

				// Поддержка вложенных ключей (например, "diagnoses.ids")
				if (filterKey.includes('.')) {
					const keys = filterKey.split('.')
					const result = { ...prev }
					let current = result

					for (let i = 0; i < keys.length - 1; i++) {
						current[keys[i]] = { ...current[keys[i]] }
						current = current[keys[i]]
					}
					current[keys[keys.length - 1]] = updatedIds

					return result
				}

				return {
					...prev,
					[filterKey]: updatedIds,
				}
			})
		},
		[filterKey, availableList, setActiveFilters],
	)
}
